<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <company-settings></company-settings>
    <!-- end row -->
    </Layout>
</template>

<script>

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import companySettings from "../components/settings/companySettings.vue"
import routes from '../../../routes.js';

export default {
  page: {
    title: "companySettings",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader,
    companySettings
  },
  data() {
    return {
      title: "Company Settings",
      name: 'companySettings',
      items: [
        {
          text: "home",
          href: '/'
        },
        {
            text: 'company settings',
            href: '/production/admin/companySettings',
            active: true
        },
      ],
      routes: routes,
    }
  },
};

</script>